/** Display formatting. Mirrors backend `apps/core/utils/{pricing,geo}.py` (BR-4, BR-11). */

const inrWhole = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 })
const inrPaise = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** 129900 → "₹1,29,900"; 99.5 → "₹99.50" (paise only when non-zero). */
export function formatInr(amount: number): string {
  const abs = Math.abs(amount)
  const body = Number.isInteger(Math.round(abs * 100) / 100)
    ? inrWhole.format(abs)
    : inrPaise.format(abs)
  return `${amount < 0 ? '-' : ''}₹${body}`
}

/** < 1 km → "350 m", else one decimal "2.4 km". */
export function formatDistance(km: number): string {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`
}

/** "919000000001" → "+91 90000 00001" (stored as 91 + 10 digits, BR-12). */
export function formatPhone(number: string): string {
  const d = number.replace(/\D/g, '')
  if (d.length === 12 && d.startsWith('91')) return `+91 ${d.slice(2, 7)} ${d.slice(7)}`
  return d ? `+${d}` : ''
}

/** `tel:` link for a stored number. */
export const telLink = (number: string) => `tel:+${number.replace(/\D/g, '')}`
